'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
/* injects from baggage-loader */

exports.default = popup;

var _lodash = require('lodash');

var _actionTypes = require('../constants/actionTypes');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var initialState = {
  popups: [] // order is important, due to z-index of popups
  // stored as { type: String, data: * }
};

function popup() {
  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
  var action = arguments[1];

  switch (action.type) {
    case _actionTypes.POPUP_SHOW:
      return _extends({}, state, {
        popups: [].concat(_toConsumableArray(state.popups), [{ type: action.popupType, data: action.popupData }])
      });

    case _actionTypes.POPUP_CLOSE:
      return _extends({}, state, {
        popups: state.popups.filter(function (t) {
          return t !== action.popupType;
        })
      });

    case _actionTypes.POPUP_CLOSE_LAST:
      return _extends({}, state, {
        popups: (0, _lodash.dropRight)(state.popups)
      });

    default:
      return state;
  }
}


//////////////////
// WEBPACK FOOTER
// ./app/reducers/popup.js
// module id = 626
// module chunks = 1